import EventEmitter from "eventemitter3";

const connector = new EventEmitter();

export default connector;
